export default "__VITE_ASSET__CIzBxljW__"